import {RPCDocs} from '@therms/react-modules'
import dayjs from 'dayjs'
import Status = RPCDocs.Patrol.GetPatrolRouteRunDetails.v2.VisitsStatus

type Visit = {
  arrivalTime?: string
  departureTime?: string
  lengthMin?: number
  status?: Status
}

export const getCompletedVisitRunStatusVariant = ({
  arrivalTime,
  departureTime,
  lengthMin,
  status,
}: Visit): 'caution' | 'positive' | undefined => {
  if (status !== Status.Completed) return undefined

  if (!lengthMin) {
    return arrivalTime && departureTime ? 'positive' : undefined
  }

  if (arrivalTime && departureTime) {
    return dayjs(departureTime).diff(arrivalTime, 'minutes') < lengthMin
      ? 'caution'
      : 'positive'
  }

  return undefined
}
